export default __webpack_public_path__ + "static/media/recentWork1.d151e94e.jpg";